import type { IDockviewDefaultTabProps } from 'dockview';
import { isSingletonPanelType } from '../../AppLayout/utils/singletonPanelTypes';
import { DefaultTabComponent } from './DefaultTabComponent';

export const TAB_COMPONENTS = {
  custom: DefaultTabComponent,
  readOnly: (props: IDockviewDefaultTabProps) => {
    return (
      <DefaultTabComponent canDuplicate={!isSingletonPanelType(props.api.component)} hideClose={true} {...props} />
    );
  },
};
